import type {CheckboxProps as MantineCheckboxProps} from '@mantine/core';
import {Checkbox as MantineCheckbox} from '@mantine/core';
import type {FC} from 'react';

/**
 * Checkbox wrapper that adapts Mantine's `onChange` to expose both the
 * source event and the resulting checked state.
 * @registry Checkbox with (event, checked) onChange signature.
 *
 * Ported from `library/elements/Checkbox`. Prop surface kept identical.
 */
export interface CheckboxProps
  extends Omit<MantineCheckboxProps, 'onChange'> {
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
}

export const Checkbox: FC<CheckboxProps> = ({onChange, ...props}) => {
  return (
    <MantineCheckbox
      onChange={e => onChange(e, e.currentTarget.checked)}
      {...props}
    />
  );
};
